import type { PropTypes } from './ProfileCardItem.types';
import type { ReactElement } from 'react';

import { Card, Flex, Skeleton, Text } from '@rango-dev/whale';
import React from 'react';

import { HoverCard } from '../HoverCard';
import { displayUserRank } from '../ProfileSummary/ProfileSummary.helpers';

import styles from './ProfileCardItem.module.css';

const VALUE_SKELETON_WIDTH = '80px';
const VALUE_SKELETON_HEIGHT = '24px';

export function ProfileCardItem(props: PropTypes): ReactElement {
  return (
    <Card variant="surface" size="1" className={styles.card}>
      <Flex align="center" gap="2">
        {props.icon}
        <Flex direction="column" align="start">
          <Flex align="center" gap="2">
            {props.loading ? (
              <Skeleton width={VALUE_SKELETON_WIDTH} height={VALUE_SKELETON_HEIGHT} />
            ) : (
              <>
                <Text size="3" weight="medium">
                  {displayUserRank(props.value)}
                </Text>
                <HoverCard description={props.description} iconSize={16} sideOffset={16} />
              </>
            )}
          </Flex>
          <Text size="2" color="gray">
            {props.title}
          </Text>
        </Flex>
      </Flex>
    </Card>
  );
}
